import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../../hooks";
import { useAppSelector } from "../../../../../../redux";
import { defaultHomeRoute } from "../../../../../../utils/routes";
import NotificationsIcon from "../../../Icons/NotificationsIcon";
import * as S from "../../ToolBar.styled";
import WalletTool from "../WalletTool/WalletTool";

const AdminToolBar = ({
  isNewNotification,
  handleNotificationClick,
}: S.ToolBarProps) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate(defaultHomeRoute);
  };

  const isLogged = useAppSelector((state) => state.user.isLogged);

  const [isWalletDropdownVisible, setIsWalletDropdownVisible] = useState(false);

  const toggleWalletDropdown = () => {
    setIsWalletDropdownVisible(!isWalletDropdownVisible);
  };

  return (
    <>
      <WalletTool
        toggleVisible={toggleWalletDropdown}
        isOpen={isWalletDropdownVisible}
        isLogged={isLogged}
      />
      <NotificationsIcon
        isNewNotification={isNewNotification}
        isToolbar
        click={handleNotificationClick}
      />
      <S.LogOutButton onClick={handleLogout}>
        <span>Log Out</span>
      </S.LogOutButton>
    </>
  );
};

export default AdminToolBar;
